var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-prompt',{staticClass:"custom-prompt",class:_vm.classList,attrs:{"color":_vm.color,"active":_vm.activePromptLocal,"acceptText":_vm.acceptText,"cancelText":null,"title":_vm.titleLocal},on:{"update:active":function($event){_vm.activePromptLocal=$event},"accept":_vm.accept}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }